/** Product version (semver x.x.x). Injected from the repo root package.json at build time. */
export const APP_VERSION: string = __APP_VERSION__;
